module.exports = __webpack_public_path__ + "static/media/arrows-left.33d34bf0.svg";